import React, { useState } from "react";
import { ContainerModal } from "../container/ContainerModal";
import { Button, Input } from "antd";
import { iconsDetailsProyectMenu } from "../../assets/icons/detailsProjectMenu";
import { typeForDetailsProyect } from "../../types/typeModalDetailsProject";

export const ModalCancelProject = ({ selectProject, editFormForProjectDetails, closeModalDetails }) => {

	const [disableButton, setDisableButton] = useState(true);

	const [loading, setLoading] = useState(false);

	const comparativeTextVSpaceId = (text = "") => {
		setDisableButton(text !== selectProject);
	};

	const finishForm = async () => {
		setLoading(true);
        await editFormForProjectDetails(typeForDetailsProyect.cancelarProyect);
		setLoading(false);

	};
	return (
		<>
			<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
				<ContainerModal
					title={"Cancelar Proyecto"}
					actionButton={() => {
						closeModalDetails();
					}}
					className={"w-[500px]"}
				>
					<div className="bg-black bg-opacity-45 w-full h-full fixed top-0 left-0 flex justify-center items-center">
						<ContainerModal className="w-[500px] " title="Cancelar proyecto" isNecesaryIcon={false}>
							<div className=" pt-2">
								<div className="h-[60px] w-full flex justify-center items-center">
									<img className="w-[56px] h-[56px] object-contain" src={iconsDetailsProyectMenu.cancelar} alt="icon" />
								</div>
								<div className="py-2 flex justify-center items-center">
									<p className="text-[12px]">
										Escribe el número del proyecto: <span className="font-bold">{selectProject}</span>
									</p>
								</div>
								<div className="">
									<Input
										placeholder="Número del proyecto"
										onChange={({ target }) => {
											comparativeTextVSpaceId(target.value);
										}}
									/>
								</div>
								<div className="w-full h-[40px] mt-4 overflow-hidden flex justify-center gap-4">
									<Button htmlType="button" onClick={closeModalDetails}>
										Cancelar
									</Button>
									<Button
										onClick={finishForm}
										type="primary"
										className={`${disableButton ? "bg-gray-300" : "bg-primaryTwo"}`}
										disabled={disableButton}
										loading={loading}
									>
										Aceptar
									</Button>
								</div>
							</div>
						</ContainerModal>
					</div>
				</ContainerModal>
			</div>
		</>
	);
};
